/* eslint-disable @typescript-eslint/naming-convention -- pre-commit-allow: PascalCase wire DTO mirrors UPS.Sparta.DTO ProspectFacilityDto, US 36008 */
/**
 * US 36008: where a facility-picker row comes from. 'Customer' is a Viewpoint facility
 * (budFacility, ParentFacilityID = KeyID); 'Prospect' is a Sparta dbo.ProspectiveCustomer site.
 */
export type FacilitySource = 'Customer' | 'Prospect';

/**
 * US 36008: one prospect site from Sparta `GET api/service-request/prospect-facilities`
 * (PascalCase, mirrors `UPS.Sparta.DTO.OperationsManagement.ProspectFacilityDto`). Shaped like a
 * Viewpoint facility row so the shared facility typeahead renders it, but it has NO
 * ParentFacilityID: it is keyed by ProspectiveCustomerId (the dbo GUID).
 */
export interface ProspectFacilityDto {
  ProspectiveCustomerId: string;
  FacilityName: string | null;
  DisplayName: string | null;
  City: string | null;
  State: string | null;
  ZIP: string | null;
  Source: 'Prospect';
}
